import LoremIpsum from "../components/loremIpsum.tsx";

export default function Dashboard() {
  return (
    <div className="p-12 flex flex-col gap-12">
      <LoremIpsum />
    </div>
  );
}
